<bit-form-field [formGroup]="formGroup">
  <textarea id="text" bitInput rows="8" name="Text" formControlName="sendText" readonly></textarea>
</bit-form-field>
<div class="tw-mb-3">
  @if (send.text.hidden) {
    <button bitButton type="button" buttonType="secondary" [block]="true" (click)="toggleText()">
      <bit-icon class="bwi-lg" [name]="showText ? 'bwi-eye' : 'bwi-eye-slash'"></bit-icon>
      {{ "toggleVisibility" | i18n }}
    </button>
  }
</div>
<div class="tw-mb-3">
  <button bitButton type="button" buttonType="primary" [block]="true" (click)="copyText()">
    <bit-icon name="bwi-clone"></bit-icon>{{ "copyValue" | i18n }}
  </button>
</div>
